// react components
import React, {
    useEffect,
} from 'react'
import {
    debounce
} from 'debounce'
import {
    isMobileOnly,
} from 'react-device-detect'
import {
    useLocation,
} from 'react-router-dom'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    reduxModaSetDeviceTypeSite,
    reduxModalErrorEventHandlerSite,
    reduxModalSetFooterHeightSite,
    reduxModalSetNavbarHeightSite,
    reduxModalSetNavbarWidthSite,
} from 'data'

// pages
import {
    NavbarBlockSite,
} from 'pages'

// services
import {
    getHostOriginSite,
} from 'services'

// main
export const NavbarWrapperSite: React.FC = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const reduxCacheSite = useSelector((state: defaultReduxState) => state.reduxCacheSite)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    let wto: any
    let wto1: any
    let wto2: any

    const pageSlug = (getHostOriginSite() === 'prod' ? location.pathname.split('/')[1] : location.pathname.split('/')[2]) || reduxCacheSite?.portfolio?.home_page_slug || undefined

    useEffect(() => {
        setHeight()
        clearTimeout(wto)
        wto = setTimeout(() => {
            setHeight()
        }, 100)
        clearTimeout(wto1)
        wto1 = setTimeout(() => {
            setHeight()
        }, 1000)
        clearTimeout(wto2)
        wto2 = setTimeout(() => {
            setHeight()
        }, 2000)
    }, [
        reduxCacheSite.portfolio,
        reduxModalSite.navbarType,
        pageSlug,
    ])

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setHeight()
            dispatch(reduxModaSetDeviceTypeSite(isMobileOnly ? 'is-mobile' : (window.innerWidth <= 767.99 ? 'is-mobile' : (window.innerWidth <= 991.99 ? 'is-tablet' : 'is-web'))))
        }, 100)
        window.addEventListener('resize', debouncedHandleResize)
        return () => {
            window.removeEventListener('resize', debouncedHandleResize)
        }
    })

    function setHeight() {
        try {
            if (!reduxCacheSite.portfolio) return
            // TODO temp
            if (reduxCacheSite.portfolio && reduxCacheSite.portfolio.id === 685 && pageSlug === 'accueil') {
                dispatch(reduxModalSetNavbarHeightSite(0))
                dispatch(reduxModalSetFooterHeightSite(0))
                return
            }
            setHeightFooter()
            if (reduxModalSite.navbarType === 'top') {
                // @ts-ignore
                const newNavbarSectionHeight = document.querySelector(`[id^="navbar-section"]`)?.offsetHeight || 0
                if (newNavbarSectionHeight && newNavbarSectionHeight !== reduxModalSite.navbarHeight) {
                    dispatch(reduxModalSetNavbarHeightSite(newNavbarSectionHeight))
                    return
                }
            } else {
                // @ts-ignore
                const newNavbarSectionWidth = document.querySelector(`[id^="navbar-section"]`)?.offsetWidth || 0
                if (newNavbarSectionWidth && newNavbarSectionWidth !== reduxModalSite.navbarWidth) {
                    dispatch(reduxModalSetNavbarWidthSite(newNavbarSectionWidth))
                    return
                }
            }
            if (reduxCacheSite.portfolio && !reduxCacheSite.portfolio.navbar && !reduxCacheSite.navbarHeightIsSet) {
                dispatch(reduxModalSetNavbarHeightSite(0))
                return
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'NavbarWrapperSite',
                'setHeight',
            ))
        }
    }

    function setHeightFooter() {
        try {
            if (reduxCacheSite.portfolio?.id === 685) {
                // @ts-ignore
                const newFooterSectionHeight = document.querySelector(`[id^="footer-section"]`)?.offsetHeight || 0
                if (newFooterSectionHeight && newFooterSectionHeight !== reduxModalSite.footerHeight) {
                    dispatch(reduxModalSetFooterHeightSite(newFooterSectionHeight))
                    return
                }
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'NavbarWrapperSite',
                'setHeightFooter',
            ))
        }
    }

    if (reduxCacheSite.portfolio?.coming_soon) return null

    if (reduxCacheSite.portfolio?.navbar) {
        return (
            <NavbarBlockSite
                linkColor={undefined}
                stylesEdit={undefined}
                pageSlug={pageSlug}
            />
        )
    }

    return null
}
